
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";

const ContactForm = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission with a delay
    setTimeout(() => {
      console.log('Form submitted:', formData);
      
      // Show success toast
      toast({
        title: "Bericht verzonden!",
        description: "Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op.",
      });
      
      // Reset form
      setFormData({
        name: '',
        company: '',
        email: '',
        message: ''
      });
      
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto" name="contact" netlify data-netlify="true">
      <div className="space-y-2">
        <Label htmlFor="name">Naam *</Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Jouw naam"
          required
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="company">Bedrijf (optioneel)</Label>
        <Input
          id="company"
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="Jouw bedrijfsnaam"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="email">E-mailadres *</Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="jouw@email.nl"
          required
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="message">Bericht *</Label>
        <Textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Laat ons weten hoe we je kunnen helpen..."
          rows={5}
          required
        />
      </div>
      
      <Button 
        type="submit" 
        className="w-full bg-noordblue hover:bg-noordblue-dark text-white"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Bezig met verzenden...' : 'Verstuur'}
      </Button>
      
      <p className="text-sm text-gray-500 text-center">
        💬 Of stuur een e-mail naar <a href="mailto:info@noord-ai.nl" className="text-noordblue hover:underline">info@noord-ai.nl</a>
      </p>
    </form>
  );
};

export default ContactForm;
